import { useAnalyticsStore } from "@/common/store/analyticsStore";

export const updateCtaLink = (link: string | null, position: number, showReason: string | null): string | null => {
  if (link === null) {
    return null;
  }

  const eventSource = useAnalyticsStore.getState().eventSource;

  try {
    const url = new URL(link);
    url.searchParams.append("pathname", window.location.pathname);
    url.searchParams.append("position", position.toString());

    if (eventSource?.name) {
      url.searchParams.append("source", eventSource.name);
    }

    if (eventSource?.id) {
      url.searchParams.append("source_id", eventSource.id);
    }

    if (showReason) {
      url.searchParams.append("reason", showReason);
    }

    return url.toString();
  } catch (e) {
    console.error(`Invalid CTA URL: ${link}`);
    return null;
  }
};
